const SUPERSCRIPT: Record<string, string> = {
  "0": "⁰",
  "1": "¹",
  "2": "²",
  "3": "³",
  "4": "⁴",
  "5": "⁵",
  "6": "⁶",
  "7": "⁷",
  "8": "⁸",
  "9": "⁹",
  "-": "⁻",
};

function toSuperscript(exponent: string): string {
  return exponent
    .split("")
    .map((char) => SUPERSCRIPT[char] ?? char)
    .join("");
}

/**
 * Format a chart value at a fixed decimal precision, falling back to scientific
 * notation ("3.4 × 10⁻⁷") when a non-zero value would round to zero at that
 * precision. Mirrors formatChartValue in i4sea-aurora-ui chart-core (aurora
 * PR #1056) so the legacy Gantt tooltip shows spectral wave energies the same
 * way as the new meteogram: real zeros stay fixed ("0.000"), readable values
 * keep fixed decimals, and sub-precision values become scientific instead of
 * an uncountable zero-run like "0.000000005".
 */
export function formatChartValue(value: number, precision: number): string {
  const fixed = value.toFixed(precision);
  if (value === 0 || Number(fixed) !== 0) return fixed;

  const [rawMantissa, rawExponent] = value.toExponential(1).split("e");
  const mantissa = rawMantissa.endsWith(".0")
    ? rawMantissa.slice(0, -2)
    : rawMantissa;
  return `${mantissa} × 10${toSuperscript(String(Number(rawExponent)))}`;
}
